import React, { FunctionComponent, RefObject } from 'react';
import { BrandCard } from '../../molecules/brandCard';
import type { Brand } from '../../../types/brand';

type Props = {
  brandIds: number[];
  instagramIcon?: string;
  noimage: string;
  hoverIcon?: string;
  isPc?: boolean;
  dataCategory: {
    brandcontent?: string;
    stopbrandcontent: string;
  };
  dataValue: any;
  shouldShowArrows: boolean;
  sliderRef: RefObject<HTMLDivElement> | null;
};

export const Presentation: FunctionComponent<Props> = ({
  brandIds,
  instagramIcon,
  noimage,
  hoverIcon,
  isPc,
  dataCategory,
  dataValue,
  shouldShowArrows,
  sliderRef,
}) => {
  return (
    <div className="brand-other">
      <div className="brand-other__container">
        <div className="brand-other__header">
          <h3 className="brand-other__title">この会社のその他のブランド</h3>
          {shouldShowArrows && (
            <div className="brand-other__arrows">
              <div className="brand-other__slider--prev" />
              <div className="brand-other__slider--next" />
            </div>
          )}
        </div>
        <div className="brand-other__slider js-brand-other-slider" ref={sliderRef}>
          {brandIds.map((brandId) => (
            <div key={brandId} className="brand-slide">
              <BrandCard
                brandId={brandId}
                instagramIcon={instagramIcon}
                noimage={noimage}
                hoverIcon={hoverIcon}
                isPc={isPc}
                dataCategory={dataCategory}
                dataValue={dataValue}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
